/** The server ended the query, for example because the viewer lost access. */
export class QueryClosed extends Error {
  readonly _tag = 'QueryClosed' as const

  constructor(readonly reason: string) {
    super(`query closed: ${reason}`)
  }
}

/**
 * A push to the session topic got no `ok` reply. `error` carries the
 * server's response; `closed` and `not_joined` mean the topic was not, or is
 * no longer, joined and the rejoin will subscribe again.
 */
export class PushFailed extends Error {
  readonly _tag = 'PushFailed' as const

  constructor(
    readonly reason: 'not_joined' | 'closed' | 'error' | 'timeout',
    readonly response: unknown
  ) {
    super(`push failed: ${reason}`)
  }
}
